
define('template!compositionPickerView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="composition-picker">\n  <p class="composition-picker-hint">\n    ';
 if (attachmentFileName) { ;
__p += '\n      ' +
((__t = ( _.i18n('compositionPicker.hintForFile', null, 'Pick the personalisation where this image should be applied:') )) == null ? '' : __t) +
'\n      <br>\n      <strong>' +
__e( attachmentFileName ) +
'</strong>\n    ';
 } else { ;
__p += '\n      ' +
((__t = ( _.i18n('compositionPicker.hint', null, 'Pick a personalisation:') )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n  </p>\n\n  ';
 if (!compositions || compositions.length === 0) { ;
__p += '\n    <div class="composition-picker-empty">\n      ' +
((__t = ( _.i18n('compositionPicker.empty', null, 'This order has no personalisation yet.') )) == null ? '' : __t) +
'\n    </div>\n  ';
 } else { ;
__p += '\n    <div class="composition-picker-list">\n      ';
 _.each(compositions, function(c, i) { ;
__p += '\n        <button type="button" class="composition-picker-item" data-index="' +
__e( i ) +
'">\n          <div class="composition-picker-thumb">\n            ';
 if (c.thumbUrl) { ;
__p += '<img src="' +
((__t = ( c.thumbUrl )) == null ? '' : __t) +
'"/>';
 } ;
__p += '\n          </div>\n          <div class="composition-picker-meta">\n            <div class="composition-picker-name">' +
__e( c.printAreaName ) +
'</div>\n            <div class="composition-picker-sub">' +
__e( c.printZoneName ) +
'</div>\n          </div>\n        </button>\n      ';
 }); ;
__p += '\n    </div>\n  ';
 } ;
__p += '\n\n  <div class="composition-picker-footer">\n    <button type="button" class="btn btn-default composition-picker-cancel">\n      ' +
((__t = ( _.i18n('common.cancel', null, 'Cancel') )) == null ? '' : __t) +
'\n    </button>\n  </div>\n</div>\n';

}
return __p
};});

